/* GumTek theme — progressive enhancement only.
   Everything below degrades to a working page if JS fails. */
(function () {
  'use strict';

  /* ---------- Announcement bar dismiss (session only) ---------- */
  var announce = document.querySelector('[data-announce]');
  if (announce) {
    try {
      if (sessionStorage.getItem('gt-announce-closed') === '1') announce.hidden = true;
    } catch (e) {}
    var closeBtn = announce.querySelector('[data-announce-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        announce.hidden = true;
        try { sessionStorage.setItem('gt-announce-closed', '1'); } catch (e) {}
      });
    }
  }

  /* ---------- Mega menu ---------- */
  var navItems = document.querySelectorAll('[data-nav-item]');
  var isTouch = window.matchMedia('(hover: none)').matches || window.innerWidth < 760;

  var navScrim = document.querySelector('[data-nav-scrim]');
  function setScrim(on) {
    if (!navScrim) return;
    if (on) {
      var header = document.querySelector('.header');
      var bottom = header ? header.getBoundingClientRect().bottom : 0;
      navScrim.style.top = Math.max(0, bottom) + 'px';
    }
    navScrim.hidden = !on;
  }

  function closeAllNav(except) {
    if (!except) setScrim(false);
    navItems.forEach(function (item) {
      if (item === except) return;
      item.setAttribute('data-open', 'false');
      var t = item.querySelector('[data-nav-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  navItems.forEach(function (item) {
    var trigger = item.querySelector('[data-nav-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var open = item.getAttribute('data-open') === 'true';
      closeAllNav(item);
      item.setAttribute('data-open', open ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      setScrim(!open);
    });

    if (!isTouch) {
      var timer;
      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        closeAllNav(item);
        item.setAttribute('data-open', 'true');
        trigger.setAttribute('aria-expanded', 'true');
        setScrim(true);
      });
      item.addEventListener('mouseleave', function () {
        timer = setTimeout(function () {
          item.setAttribute('data-open', 'false');
          trigger.setAttribute('aria-expanded', 'false');
          setScrim(false);
        }, 120);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllNav(null);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nav-item]')) closeAllNav(null);
  });

  /* ---------- Mobile nav ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.getAttribute('data-mobile-open') === 'true';
      nav.setAttribute('data-mobile-open', open ? 'false' : 'true');
      navToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    val = btn.getAttribute('data-qty') === 'up' ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery ---------- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var id = thumb.getAttribute('data-media-id');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
      gallery.querySelectorAll('[data-gallery-image]').forEach(function (img) {
        img.hidden = img.getAttribute('data-media-id') !== id;
      });
      var counter = gallery.querySelector('[data-gallery-index]');
      if (counter) counter.textContent = thumb.getAttribute('data-index') || '1';
    });
  }

  /* ---------- Gallery arrows ---------- */
  (function () {
    var g = document.querySelector('[data-gallery]');
    if (!g) return;
    function step(dir) {
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-thumb]'));
      if (!thumbs.length) return;
      var cur = thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
      var next = thumbs[(cur + dir + thumbs.length) % thumbs.length];
      if (next) next.click();
    }
    var prev = g.querySelector('[data-gallery-prev]');
    var next = g.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  })();

  /* ==========================================================
     Add to basket without leaving the page, then offer extras
     ========================================================== */
  (function () {
    var modal = document.querySelector('[data-added-modal]');
    var form = document.querySelector('.pdp__form');
    if (!modal || !form) return;

    var slot = modal.querySelector('[data-xtras-slot]');
    var wrap = modal.querySelector('[data-xtras]');
    var empty = modal.querySelector('[data-xtras-empty]');
    var productId = modal.dataset.productId;

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var c = modal.querySelector('[data-modal-close]');
      if (c) c.focus();
    }

    function bumpCount(n) {
      document.querySelectorAll('.hact__count').forEach(function (el) { el.textContent = n; });
      var basket = document.querySelector('.hact[href*="/cart"]');
      if (basket && !basket.querySelector('.hact__count') && n > 0) {
        var s = document.createElement('span');
        s.className = 'hact__count'; s.textContent = n;
        basket.appendChild(s);
      }
    }

    function refreshCount() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { bumpCount(c.item_count); })
        .catch(function () {});
    }

    function loadExtras() {
      // Complementary products are chosen per product in Search & Discovery.
      // Falls back to related products when none are set.
      var base = '/recommendations/products?section_id=cart-extras&product_id=' + productId + '&limit=4';
      fetch(base + '&intent=complementary')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (html && html.indexOf('xtra__title') !== -1) return html;
          return fetch(base + '&intent=related').then(function (r) { return r.ok ? r.text() : ''; });
        })
        .then(function (html) {
          var holder = document.createElement('div');
          holder.innerHTML = html || '';
          var grid = holder.querySelector('.xtras__grid');
          if (grid) { slot.innerHTML = grid.outerHTML; wrap.hidden = false; empty.hidden = true; }
          else { wrap.hidden = true; empty.hidden = false; }
        })
        .catch(function () { wrap.hidden = true; empty.hidden = false; });
    }

    form.addEventListener('submit', function (e) {
      var id = form.querySelector('[name="id"]');
      if (!id || !id.value) return;                 // let it post normally
      e.preventDefault();
      var btn = form.querySelector('[data-add-button]');
      var was = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: new URLSearchParams(new FormData(form)).toString()
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { refreshCount(); loadExtras(); openModal(); })
        .catch(function () { form.submit(); })      // fall back to a normal post
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = was; } });
    });

    modal.addEventListener('click', function (e) {
      var add = e.target.closest('[data-xtra-add]');
      if (!add) return;
      var vid = add.dataset.variantId;
      var label = add.textContent;
      add.disabled = true; add.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () { add.textContent = 'Added'; add.classList.add('xtra__add--done'); refreshCount(); })
        .catch(function () { add.disabled = false; add.textContent = label; });
    });
  })();

  /* ---------- Image zoom ----------
     Opens the largest render, pans with the pointer, keyboard accessible. */
  (function () {
    var zoom = document.querySelector('[data-zoom]');
    if (!zoom) return;
    var stage = zoom.querySelector('[data-zoom-stage]');
    var opener = document.querySelector('[data-zoom-open]');
    var gallery = document.querySelector('[data-gallery]');

    function currentId() {
      var on = gallery && gallery.querySelector('[data-gallery-image]:not([hidden])');
      return on ? on.getAttribute('data-media-id') : null;
    }
    function show(id) {
      zoom.querySelectorAll('[data-zoom-image]').forEach(function (img) {
        img.hidden = img.getAttribute('data-media-id') !== id;
        img.style.transformOrigin = '50% 50%';
      });
      zoom.querySelectorAll('[data-zoom-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', b.getAttribute('data-media-id') === id ? 'true' : 'false');
      });
    }
    function open() {
      var id = currentId();
      if (id) show(id);
      zoom.hidden = false;
      document.body.style.overflow = 'hidden';
      var c = zoom.querySelector('[data-zoom-close]');
      if (c) c.focus();
    }
    function close() {
      zoom.hidden = true;
      document.body.style.overflow = '';
      if (opener) opener.focus();
    }

    if (opener) opener.addEventListener('click', open);
    if (gallery) {
      var main = gallery.querySelector('.gallery__stage');
      if (main) main.addEventListener('click', function (e) {
        if (e.target.closest('button, a')) return;
        open();
      });
    }
    zoom.addEventListener('click', function (e) {
      if (e.target.closest('[data-zoom-close]')) { close(); return; }
      var th = e.target.closest('[data-zoom-thumb]');
      if (th) { show(th.getAttribute('data-media-id')); return; }
      if (e.target === zoom || e.target === stage) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!zoom.hidden && e.key === 'Escape') close();
    });

    // Pan: map pointer position onto the image's transform origin
    stage.addEventListener('mousemove', function (e) {
      var img = stage.querySelector('[data-zoom-image]:not([hidden])');
      if (!img) return;
      var r = stage.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });
  })();

  /* ---------- Delivery / collection tabs ---------- */
  (function () {
    var tabs = document.querySelector('[data-fulfil-tabs]');
    if (!tabs) return;
    var root = tabs.closest('[data-modal]');

    function activate(which) {
      tabs.querySelectorAll('[data-fulfil-tab]').forEach(function (b) {
        b.setAttribute('aria-selected', b.dataset.fulfilTab === which ? 'true' : 'false');
      });
      root.querySelectorAll('[data-fulfil-panel]').forEach(function (p) {
        p.hidden = p.dataset.fulfilPanel !== which;
      });
    }
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fulfil-tab]');
      if (b) activate(b.dataset.fulfilTab);
    });
    // Opening the modal from a specific row lands on the matching tab
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-fulfil-open]');
      if (o) activate(o.getAttribute('data-fulfil-open') === 'pickup' ? 'collect' : 'delivery');
    });

    var ht = root.querySelector('[data-hours-toggle]');
    var hp = root.querySelector('[data-hours-panel]');
    if (ht && hp) ht.addEventListener('click', function () {
      var open = ht.getAttribute('aria-expanded') === 'true';
      ht.setAttribute('aria-expanded', open ? 'false' : 'true');
      hp.hidden = open;
    });
  })();

  /* ==========================================================
     Inline fulfilment chooser
     Postcode in -> real dates out, shown next to the buy button
     rather than in a popup.
     ========================================================== */
  (function () {
    var box = document.querySelector('[data-fulfil-choice]');
    var field = document.querySelector('[data-inline-postcode]');
    var go = document.querySelector('[data-inline-check]');
    var err = document.querySelector('[data-inline-error]');
    if (!box || !field || !go) return;

    var optsEl = document.querySelector('[data-delivery-options]');
    var options = [];
    try { options = JSON.parse(optsEl.textContent); } catch (e) {}

    var cutoff = parseInt(box.dataset.cutoff, 10) || 14;
    var threshold = parseFloat(box.dataset.freeThreshold) || 0;
    var price = parseFloat(box.dataset.price) || 0;
    var canCollect = box.dataset.collectAvailable === 'true';
    var collectTime = box.dataset.collectTime || 'within 1 hour';
    var storeName = box.dataset.collectStore || 'our shop';

    function norm(pc){ return String(pc).toUpperCase().replace(/[^A-Z0-9]/g,''); }
    function outward(pc){ var s = norm(pc); return (s.length < 5 || s.length > 7) ? null : s.slice(0, s.length - 3); }
    function areaOf(o){ return o.replace(/[0-9].*$/, ''); }
    function districtOf(o){ var m = o.match(/\d+/); return m ? parseInt(m[0], 10) : null; }
    function zoneOf(o){
      var a = areaOf(o), d = districtOf(o);
      if (a === 'BT') return { key:'ni', label:'Northern Ireland' };
      if (a === 'IM') return { key:'offshore', label:'Isle of Man' };
      if (a === 'GY' || a === 'JE') return { key:'offshore', label:'Channel Islands' };
      if (['HS','ZE','IV','KW'].indexOf(a) !== -1) return { key:'highlands', label:'Scottish Highlands & Islands' };
      if (a === 'AB' && d !== null && ((d>=31&&d<=38)||(d>=40&&d<=56))) return { key:'highlands', label:'Scottish Highlands' };
      if (a === 'FK' && d !== null && d>=17 && d<=21) return { key:'highlands', label:'Scottish Highlands' };
      if (a === 'PA' && d !== null && ((d>=20&&d<=49)||(d>=60&&d<=78))) return { key:'highlands', label:'Scottish Islands' };
      if (a === 'PH' && d !== null && d>=15 && d<=50) return { key:'highlands', label:'Scottish Highlands' };
      if (a === 'KA' && d !== null && (d===27||d===28)) return { key:'highlands', label:'Isle of Arran' };
      if (a === 'TR' && d !== null && d>=21 && d<=25) return { key:'highlands', label:'Isles of Scilly' };
      return { key:'mainland', label:'UK mainland' };
    }
    function isWorkday(d){ var n = d.getDay(); return n !== 0 && n !== 6; }
    function addWorkdays(d, n){ var x = new Date(d.getTime()); while (n > 0){ x.setDate(x.getDate()+1); if (isWorkday(x)) n--; } return x; }
    function money(n){ return n === 0 ? 'FREE' : '£' + n.toFixed(2); }
    function sameDay(a, b){ return a.toDateString() === b.toDateString(); }
    function friendly(d){
      var now = new Date();
      var tom = new Date(now.getTime()); tom.setDate(tom.getDate() + 1);
      if (sameDay(d, now)) return 'today';
      if (sameDay(d, tom)) return 'tomorrow';
      return d.toLocaleDateString('en-GB', { weekday:'long', day:'numeric', month:'short' });
    }
    function dispatchDay(){
      var now = new Date(), d = new Date(now.getTime());
      if (!isWorkday(d) || now.getHours() >= cutoff) d = addWorkdays(d, 1);
      return d;
    }

    var state = { zone:null, options:[], soonest:null };

    function compute(zone){
      var disp = dispatchDay();
      var remote = zone.key !== 'mainland';
      var rows = [], soonest = null;
      options.forEach(function (o) {
        if (remote && !o.remote_ok) { rows.push({ name:o.name, blocked:true }); return; }
        var extra = remote ? (o.remote_extra || 0) : 0;
        var lo = addWorkdays(disp, (o.lead_min || 0) + extra);
        var hi = addWorkdays(disp, (o.lead_max || 0) + extra);
        var cost = parseFloat(o.price) || 0;
        if (o.free_over && threshold > 0 && price >= threshold) cost = 0;
        rows.push({ name:o.name, lo:lo, hi:hi, cost:cost, note:o.note });
        if (!soonest || lo < soonest) soonest = lo;
      });
      return { rows:rows, soonest:soonest, zone:zone };
    }

    function pick(which) {
      box.querySelectorAll('[data-fulfil-pick]').forEach(function (b) {
        b.setAttribute('aria-checked', b.dataset.fulfilPick === which ? 'true' : 'false');
      });
      var d = box.querySelector('[data-fulfil-detail]');
      if (which === 'collect') {
        d.innerHTML = canCollect
          ? '<p class="fget__lead">Order now, collect <strong>' + collectTime + '</strong> at:</p>' +
            '<p class="fget__store"><strong>' + storeName + '</strong></p>' +
            '<p class="fget__note">Reserve and pay online, then collect from the counter.</p>'
          : '<p class="fget__note">This one is not in stock at the shop right now. Choose delivery, or call us and we will order it in.</p>';
        return;
      }
      var rows = state.options;
      var html = '<p class="fget__lead">Order now, get it <strong>' + friendly(state.soonest) + '</strong></p><ul class="fget__list">';
      rows.forEach(function (r) {
        if (r.blocked) {
          html += '<li class="fget__off"><span>' + r.name + '</span><em>Not available to ' + state.zone.label + '</em></li>';
          return;
        }
        var when = friendly(r.lo) === friendly(r.hi) ? friendly(r.lo) : friendly(r.lo) + ' – ' + friendly(r.hi);
        html += '<li><span>' + r.name + '<em>' + when + (r.note ? ' · ' + r.note : '') + '</em></span>' +
                '<b class="' + (r.cost === 0 ? 'fget__free' : '') + '">' + money(r.cost) + '</b></li>';
      });
      html += '</ul><p class="fget__note">Working days only. Final rates confirmed at checkout.</p>';
      d.innerHTML = html;
    }

    function run() {
      var o = outward(field.value);
      if (!o) {
        if (err) { err.hidden = false; err.textContent = 'Please enter a full UK postcode, including the second half.'; }
        box.hidden = true;
        return;
      }
      if (err) err.hidden = true;
      var zone = zoneOf(o);
      var calc = compute(zone);
      state = { zone:zone, options:calc.rows, soonest:calc.soonest };

      var cw = box.querySelector('[data-collect-when]');
      var dw = box.querySelector('[data-delivery-when]');
      if (cw) cw.innerHTML = canCollect
        ? '<span class="fget__tick">' + tick() + '</span><span>Available <strong>' + collectTime + '</strong></span>'
        : '<span class="fget__cross">&minus;</span><span>Not in stock here</span>';
      if (dw) dw.innerHTML = '<span class="fget__tick">' + tick() + '</span><span>Get it <strong>' +
                             friendly(calc.soonest) + '</strong></span>';

      box.hidden = false;
      pick(canCollect ? 'collect' : 'delivery');
    }

    function tick() {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
             'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5l5 5 10-11"/></svg>';
    }

    go.addEventListener('click', run);
    field.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fulfil-pick]');
      if (b) pick(b.dataset.fulfilPick);
    });
  })();

  /* ---------- Variant selection ----------
     Reads the JSON blob Shopify renders, swaps price/availability/URL. */
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var select = form.querySelector('[data-variant-select]');
    var idInput = form.querySelector('[data-variant-id]');
    // Keep the hidden id in step with the select on first paint too
    if (select && idInput) idInput.value = select.value;
    var priceEl = form.querySelector('[data-variant-price]');
    var wasEl = form.querySelector('[data-variant-was]');
    var skuEl = form.querySelector('[data-variant-sku]');
    var submit = form.querySelector('[data-add-button]');
    var stockEl = form.querySelector('[data-variant-stock]');
    if (!select) return;

    function money(cents) {
      var cur = form.getAttribute('data-currency') || 'GBP';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency', currency: cur
        }).format(cents / 100);
      } catch (e) {
        return '£' + (cents / 100).toFixed(2);
      }
    }

    select.addEventListener('change', function () {
      var v = variants.filter(function (x) { return String(x.id) === select.value; })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          wasEl.textContent = money(v.compare_at_price);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }
      if (skuEl) skuEl.textContent = v.sku || '';
      if (stockEl) {
        stockEl.textContent = v.available ? 'In stock' : 'Out of stock';
        stockEl.className = v.available ? 'card__stock' : 'card__stock card__stock--out';
      }
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? 'Add to basket' : 'Out of stock';
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  /* ---------- Tabs ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var buttons = group.querySelectorAll('[data-tab]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab');
        buttons.forEach(function (b) {
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        group.parentNode.querySelectorAll('[data-tab-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-tab-panel') !== target;
        });
      });
    });
  });

  /* ---------- Share ----------
     Native share sheet on mobile, clipboard everywhere else. */
  document.querySelectorAll('[data-share]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.dataset.url, title = btn.dataset.title;
      var label = btn.querySelector('span');
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      var done = function () {
        if (!label) return;
        var was = label.textContent;
        label.textContent = 'Link copied';
        setTimeout(function () { label.textContent = was; }, 1800);
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(done).catch(function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = url; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  });

  /* ---------- Save for later ----------
     Stored in the shopper's own browser. There is no wishlist page; this only
     remembers the state of the button. A real wishlist needs an app. */
  document.querySelectorAll('[data-save-toggle]').forEach(function (btn) {
    var handle = btn.dataset.handle;
    var label = btn.querySelector('[data-save-label]');
    function read() {
      try { return JSON.parse(localStorage.getItem('gt-saved') || '[]'); }
      catch (e) { return []; }
    }
    function paint(on) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (label) label.textContent = on ? 'Saved' : 'Save for later';
    }
    paint(read().indexOf(handle) !== -1);
    btn.addEventListener('click', function () {
      var list = read();
      var i = list.indexOf(handle);
      if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
      try { localStorage.setItem('gt-saved', JSON.stringify(list)); } catch (e) {}
      paint(i === -1);
    });
  });

  /* ---------- Inc VAT / Ex VAT display toggle ----------
     Display only. Checkout always charges the real VAT-inclusive price, and
     anything tagged margin-scheme is left alone: on second-hand goods sold
     under the VAT margin scheme there is no reclaimable VAT to show. */
  var vat = document.querySelector('[data-vat-toggle]');
  if (vat) {
    var sw = vat.querySelector('.vat__switch');
    var rate = parseFloat(vat.dataset.rate || '20') / 100;

    function priceNodes() {
      return document.querySelectorAll('.price__now, .price__was, .price__save');
    }

    function apply(ex) {
      priceNodes().forEach(function (el) {
        if (el.closest('[data-margin-scheme]')) return;
        if (!el.dataset.incVat) el.dataset.incVat = el.textContent;
        var src = el.dataset.incVat;
        if (!ex) { el.textContent = src; return; }
        el.textContent = src.replace(/([£$€]\s?)([\d,]+(?:\.\d{2})?)/g, function (m, sym, num) {
          var v = parseFloat(num.replace(/,/g, ''));
          if (isNaN(v)) return m;
          return sym + (v / (1 + rate)).toFixed(2);
        });
      });
      vat.setAttribute('data-ex', ex ? 'true' : 'false');
      sw.setAttribute('aria-checked', ex ? 'true' : 'false');
      try { sessionStorage.setItem('gt-ex-vat', ex ? '1' : '0'); } catch (e) {}
    }

    var stored = '0';
    try { stored = sessionStorage.getItem('gt-ex-vat') || '0'; } catch (e) {}
    if (stored === '1') apply(true);

    sw.addEventListener('click', function () {
      apply(sw.getAttribute('aria-checked') !== 'true');
    });
  }


  /* ==========================================================
     Modals
     ========================================================== */
  (function () {
    var lastTrigger = null;

    function focusables(el) {
      return Array.prototype.filter.call(
        el.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'),
        function (n) { return n.offsetParent !== null; }
      );
    }

    function open(id, trigger) {
      var m = document.getElementById(id);
      if (!m) return;
      lastTrigger = trigger || null;
      m.hidden = false;
      document.body.style.overflow = 'hidden';
      var f = focusables(m);
      if (f.length) f[0].focus();
    }

    function close(m) {
      if (!m || m.hidden) return;
      m.hidden = true;
      document.body.style.overflow = '';
      if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-modal-open]');
      if (opener) { e.preventDefault(); open(opener.getAttribute('data-modal-open'), opener); return; }
      var closer = e.target.closest('[data-modal-close]');
      if (closer) { close(closer.closest('[data-modal]')); }
    });

    document.addEventListener('keydown', function (e) {
      var m = document.querySelector('[data-modal]:not([hidden])');
      if (!m) return;
      if (e.key === 'Escape') { close(m); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(m);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  /* ==========================================================
     Delivery checker
     Postcode -> UK zone -> options with real working-day dates.
     These are the merchant's published bands, not live carrier
     rates; checkout remains the source of truth.
     ========================================================== */
  (function () {
    var root = document.querySelector('[data-delivery]');
    if (!root) return;

    var form = root.querySelector('[data-delivery-form]');
    var input = root.querySelector('[data-postcode]');
    var errEl = root.querySelector('[data-postcode-error]');
    var results = root.querySelector('[data-delivery-results]');
    var zoneEl = root.querySelector('[data-zone-label]');
    var listEl = root.querySelector('[data-delivery-list]');

    var options = [];
    try { options = JSON.parse(root.querySelector('[data-delivery-options]').textContent); } catch (e) {}

    var cutoff = parseInt(root.dataset.cutoff, 10) || 14;
    var threshold = parseFloat(root.dataset.freeThreshold) || 0;
    var price = parseFloat(root.dataset.price) || 0;

    // Outward code of a UK postcode: the part before the space
    function outward(pc) {
      var s = String(pc).toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (s.length < 5 || s.length > 7) return null;
      return s.slice(0, s.length - 3);
    }
    function areaOf(o) { return o.replace(/[0-9].*$/, ''); }
    function districtOf(o) { var m = o.match(/\d+/); return m ? parseInt(m[0], 10) : null; }

    // Standard UK surcharge / extended-delivery zones
    function zoneOf(o) {
      var a = areaOf(o), d = districtOf(o);
      if (a === 'BT') return { key: 'ni', label: 'Northern Ireland' };
      if (a === 'IM') return { key: 'offshore', label: 'Isle of Man' };
      if (a === 'GY' || a === 'JE') return { key: 'offshore', label: 'Channel Islands' };
      if (a === 'HS' || a === 'ZE' || a === 'IV' || a === 'KW')
        return { key: 'highlands', label: 'Scottish Highlands & Islands' };
      if (a === 'AB' && d !== null && ((d >= 31 && d <= 38) || (d >= 40 && d <= 56)))
        return { key: 'highlands', label: 'Scottish Highlands' };
      if (a === 'FK' && d !== null && d >= 17 && d <= 21)
        return { key: 'highlands', label: 'Scottish Highlands' };
      if (a === 'PA' && d !== null && ((d >= 20 && d <= 49) || (d >= 60 && d <= 78)))
        return { key: 'highlands', label: 'Scottish Islands' };
      if (a === 'PH' && d !== null && d >= 15 && d <= 50)
        return { key: 'highlands', label: 'Scottish Highlands' };
      if (a === 'KA' && d !== null && (d === 27 || d === 28))
        return { key: 'highlands', label: 'Isle of Arran' };
      if (a === 'TR' && d !== null && d >= 21 && d <= 25)
        return { key: 'highlands', label: 'Isles of Scilly' };
      return { key: 'mainland', label: 'UK mainland' };
    }

    function isWorkday(d) { var n = d.getDay(); return n !== 0 && n !== 6; }
    function addWorkdays(d, n) {
      var x = new Date(d.getTime());
      while (n > 0) { x.setDate(x.getDate() + 1); if (isWorkday(x)) n--; }
      return x;
    }
    function fmt(d) {
      return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    }
    function money(n) { return n === 0 ? 'FREE' : '£' + n.toFixed(2); }

    function dispatchDay() {
      var now = new Date();
      var d = new Date(now.getTime());
      if (!isWorkday(d) || now.getHours() >= cutoff) d = addWorkdays(d, 1);
      return { date: d, sameDay: isWorkday(now) && now.getHours() < cutoff };
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var o = outward(input.value);
      if (!o) {
        errEl.hidden = false;
        errEl.textContent = 'Please enter a full UK postcode, including the second half.';
        results.hidden = true;
        return;
      }
      errEl.hidden = true;

      var zone = zoneOf(o);
      var disp = dispatchDay();
      var remote = zone.key !== 'mainland';

      zoneEl.innerHTML = '<strong>' + o + '</strong> &mdash; ' + zone.label +
        '<br><span>' + (disp.sameDay
          ? 'Order in the next few hours and this is dispatched today.'
          : 'Next dispatch ' + fmt(disp.date) + '.') + '</span>';

      listEl.innerHTML = '';
      var any = false;

      options.forEach(function (opt) {
        if (remote && !opt.remote_ok) {
          listEl.insertAdjacentHTML('beforeend',
            '<li class="deliveryopt deliveryopt--off"><div><strong>' + opt.name + '</strong>' +
            '<em>Not available to ' + zone.label + '</em></div></li>');
          return;
        }
        any = true;
        var extra = remote ? (opt.remote_extra || 0) : 0;
        var lo = addWorkdays(disp.date, (opt.lead_min || 0) + extra);
        var hi = addWorkdays(disp.date, (opt.lead_max || 0) + extra);
        var cost = parseFloat(opt.price) || 0;
        if (opt.free_over && threshold > 0 && price >= threshold) cost = 0;
        var when = fmt(lo) === fmt(hi) ? fmt(lo) : fmt(lo) + ' – ' + fmt(hi);

        listEl.insertAdjacentHTML('beforeend',
          '<li class="deliveryopt"><div><strong>' + opt.name + '</strong>' +
          '<em>Arrives ' + when + '</em>' +
          (opt.note ? '<em class="deliveryopt__note">' + opt.note + '</em>' : '') +
          '</div><span class="deliveryopt__price' + (cost === 0 ? ' deliveryopt__price--free' : '') + '">' +
          money(cost) + '</span></li>');
      });

      if (!any) {
        listEl.insertAdjacentHTML('beforeend',
          '<li class="deliveryopt"><div><em>No standard service reaches ' + zone.label +
          '. Contact us and we will quote a courier.</em></div></li>');
      }
      results.hidden = false;
    });
  })();

  /* ---------- Open / closed right now ---------- */
  (function () {
    var table = document.querySelector('[data-opening-hours]');
    var out = document.querySelector('[data-open-now]');
    if (!table || !out) return;
    var now = new Date();
    var row = table.querySelector('tr[data-day="' + now.getDay() + '"]');
    if (!row) return;
    row.classList.add('hours__today');
    var txt = row.cells[1].textContent.trim();
    if (/closed/i.test(txt)) { out.textContent = 'Closed today.'; out.hidden = false; return; }
    var m = txt.match(/(\d{1,2}):(\d{2}).*?(\d{1,2}):(\d{2})/);
    if (!m) return;
    var mins = now.getHours() * 60 + now.getMinutes();
    var o = +m[1] * 60 + +m[2], c = +m[3] * 60 + +m[4];
    out.textContent = (mins >= o && mins < c)
      ? 'Open now until ' + m[3] + ':' + m[4] + '.'
      : 'Closed right now.';
    out.hidden = false;
  })();

  /* ==========================================================
     Predictive search
     Debounced, aborts the previous request, full keyboard support.
     Falls back to a normal search submit if anything fails.
     ========================================================== */
  (function () {
    var wrap = document.querySelector('[data-psearch]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-psearch-input]');
    var panel = wrap.querySelector('[data-psearch-results]');
    var clear = wrap.querySelector('[data-psearch-clear]');
    var status = wrap.querySelector('[data-psearch-status]');
    if (!input || !panel) return;

    var MIN = 2, DELAY = 220;
    var timer = null, controller = null, index = -1;

    function items() { return panel.querySelectorAll('[data-ps-item]'); }

    function close() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      index = -1;
    }

    function highlight(n) {
      var list = items();
      if (!list.length) return;
      if (n < 0) n = list.length - 1;
      if (n >= list.length) n = 0;
      index = n;
      list.forEach(function (el, i) {
        var on = i === index;
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        el.classList.toggle('is-active', on);
        if (on) {
          if (!el.id) el.id = 'ps-item-' + i;
          input.setAttribute('aria-activedescendant', el.id);
          el.scrollIntoView({ block: 'nearest' });
        }
      });
    }

    function fetchResults(term) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = '/search/suggest?q=' + encodeURIComponent(term) +
                '&section_id=predictive-search' +
                '&resources[limit]=6&resources[type]=product,query,collection,page';

      fetch(url, { signal: controller.signal })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (html) {
          // The endpoint returns the whole section wrapper; take the panel out of it.
          var holder = document.createElement('div');
          holder.innerHTML = html;
          var content = holder.querySelector('.psearch__panel');
          if (!content) { close(); return; }
          panel.innerHTML = content.outerHTML;
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          index = -1;
          if (status) {
            var n = panel.querySelectorAll('.psearch__products li').length;
            status.textContent = n ? n + ' product suggestions available' : 'No suggestions';
          }
        })
        .catch(function (e) { if (e.name !== 'AbortError') close(); });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      if (clear) clear.hidden = term.length === 0;
      clearTimeout(timer);
      if (term.length < MIN) { close(); return; }
      timer = setTimeout(function () { fetchResults(term); }, DELAY);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN && panel.innerHTML) {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(index + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(index - 1); }
      else if (e.key === 'Enter' && index >= 0) {
        var el = items()[index];
        if (el) { e.preventDefault(); window.location.href = el.getAttribute('href'); }
      } else if (e.key === 'Escape') { close(); input.blur(); }
    });

    if (clear) {
      clear.hidden = input.value.trim().length === 0;
      clear.addEventListener('click', function () {
        input.value = ''; clear.hidden = true; close(); input.focus();
      });
    }

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
  })();

  /* ==========================================================
     Compare
     Selections live in the shopper's own browser, so no backend and
     no reload. Spec rails are read from the DOM of each row.
     ========================================================== */
  (function () {
    var tray = document.querySelector('[data-compare-tray]');
    if (!tray) return;

    var itemsEl = tray.querySelector('[data-compare-items]');
    var countEl = tray.querySelector('[data-compare-count]');
    var bodyEl = document.querySelector('[data-compare-body]');
    var MAX = 4;
    var picked = [];

    function specsFor(handle) {
      var box = document.querySelector('[data-compare][data-handle="' + handle + '"]');
      var row = box && box.closest('.row');
      if (!row) return [];
      return Array.prototype.map.call(row.querySelectorAll('.row__specs li'), function (li) {
        var b = li.querySelector('b');
        var label = b ? b.textContent.replace(/:$/, '') : '';
        var value = b ? li.textContent.replace(b.textContent, '').trim() : li.textContent.trim();
        return { label: label, value: value || '\u2713' };
      });
    }

    function paint() {
      countEl.textContent = picked.length;
      tray.hidden = picked.length === 0;
      itemsEl.innerHTML = picked.map(function (p) {
        return '<span class="comparetray__chip">' +
          (p.image ? '<img src="' + p.image + '" alt="">' : '') +
          '<span>' + p.title + '</span>' +
          '<button type="button" data-compare-remove="' + p.handle + '" aria-label="Remove">&times;</button></span>';
      }).join('');
      document.querySelectorAll('[data-compare]').forEach(function (cb) {
        var on = picked.some(function (p) { return p.handle === cb.dataset.handle; });
        cb.checked = on;
        cb.disabled = !on && picked.length >= MAX;
      });
    }

    document.addEventListener('change', function (e) {
      var cb = e.target.closest('[data-compare]');
      if (!cb) return;
      var h = cb.dataset.handle;
      if (cb.checked) {
        if (picked.length >= MAX) { cb.checked = false; return; }
        picked.push({
          handle: h, title: cb.dataset.title, url: cb.dataset.url,
          price: cb.dataset.price, image: cb.dataset.image
        });
      } else {
        picked = picked.filter(function (p) { return p.handle !== h; });
      }
      paint();
    });

    tray.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-compare-remove]');
      if (rm) {
        picked = picked.filter(function (p) { return p.handle !== rm.getAttribute('data-compare-remove'); });
        paint();
        return;
      }
      if (e.target.closest('[data-compare-clear]')) { picked = []; paint(); return; }
      if (e.target.closest('[data-compare-open]')) { build(); openCompare(); }
    });

    function openCompare() {
      var m = document.getElementById('modal-compare');
      if (m) { m.hidden = false; document.body.style.overflow = 'hidden'; }
    }

    function build() {
      if (!bodyEl) return;
      if (picked.length < 2) {
        bodyEl.innerHTML = '<p class="modal__lead">Tick at least two products to compare them.</p>';
        return;
      }
      // Union of every spec label across the picked products, order preserved
      var labels = [], data = {};
      picked.forEach(function (p) {
        data[p.handle] = {};
        specsFor(p.handle).forEach(function (s) {
          if (!s.label) return;
          if (labels.indexOf(s.label) === -1) labels.push(s.label);
          data[p.handle][s.label] = s.value;
        });
      });

      var html = '<div class="cmp"><table class="cmp__table"><thead><tr><th></th>';
      picked.forEach(function (p) {
        html += '<td><a href="' + p.url + '">' +
          (p.image ? '<img src="' + p.image + '" alt="">' : '') +
          '<strong>' + p.title + '</strong></a>' +
          '<span class="cmp__price">' + p.price + '</span></td>';
      });
      html += '</tr></thead><tbody>';
      labels.forEach(function (l) {
        var vals = picked.map(function (p) { return data[p.handle][l] || '\u2014'; });
        var same = vals.every(function (v) { return v === vals[0]; });
        html += '<tr class="' + (same ? '' : 'cmp__differs') + '"><th scope="row">' + l + '</th>';
        vals.forEach(function (v) { html += '<td>' + v + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table><p class="modal__hint">Rows where the products differ are highlighted.</p></div>';
      bodyEl.innerHTML = html;
    }

    paint();
  })();

  /* ---------- Copy discount code ---------- */
  document.querySelectorAll('[data-coupon-copy]').forEach(function (btn) {
    var original = btn.textContent;

    function flash(msg) {
      btn.textContent = msg;
      btn.setAttribute('data-copied', 'true');
      setTimeout(function () {
        btn.textContent = original;
        btn.removeAttribute('data-copied');
      }, 1800);
    }

    function legacyCopy(code) {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      return ok;
    }

    btn.addEventListener('click', function () {
      var code = btn.dataset.code || '';

      function fallback() {
        if (legacyCopy(code)) { flash('Copied'); return; }
        // Nothing worked — select the code so it can be copied manually.
        var el = btn.parentNode.querySelector('[data-coupon-code]');
        if (el && window.getSelection) {
          var r = document.createRange();
          r.selectNodeContents(el);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(r);
        }
        flash('Copy it');
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () { flash('Copied'); }, fallback);
      } else {
        fallback();
      }
    });
  });

  /* ---------- Grid / list toggle ----------
     Both layouts are in the markup; this only flips which one displays,
     so switching costs nothing and works with JS off (grid is the default). */
  (function () {
    var results = document.querySelector('[data-results]');
    var toggle = document.querySelector('[data-view-toggle]');
    if (!results || !toggle) return;

    function apply(view) {
      results.setAttribute('data-view', view);
      toggle.querySelectorAll('[data-view]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-view') === view ? 'true' : 'false');
      });
      try { localStorage.setItem('gt-results-view', view); } catch (e) {}
    }

    var saved = 'grid';
    try { saved = localStorage.getItem('gt-results-view') || 'grid'; } catch (e) {}
    apply(saved);

    toggle.addEventListener('click', function (e) {
      var b = e.target.closest('[data-view]');
      if (b) apply(b.getAttribute('data-view'));
    });
  })();


  /* ==========================================================
     Hero carousel
     Autoplay pauses on hover, on focus, when the tab is hidden,
     and is disabled outright for prefers-reduced-motion.
     ========================================================== */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    var slides = root.querySelectorAll('[data-carousel-slide]');
    var dots = root.querySelectorAll('[data-carousel-dot]');
    var pauseBtn = root.querySelector('[data-carousel-pause]');
    if (slides.length < 2) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = parseInt(root.dataset.interval, 10) || 6000;
    var wants = root.dataset.autoplay === 'true' && !reduced;
    var i = 0, timer = null, paused = false;

    function show(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function start() { if (wants && !paused) { stop(); timer = setInterval(function () { show(i + 1); }, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    root.querySelector('[data-carousel-next]').addEventListener('click', function () { show(i + 1); start(); });
    root.querySelector('[data-carousel-prev]').addEventListener('click', function () { show(i - 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.dataset.carouselDot, 10)); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        paused ? stop() : start();
      });
    }

    // Swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) show(dx < 0 ? i + 1 : i - 1);
      x0 = null; start();
    });

    show(0); start();
  });

  /* ==========================================================
     Recently viewed
     Records the current product, renders the rest. Held in the
     shopper's own browser; nothing leaves the device.
     ========================================================== */
  (function () {
    var KEY = 'gt-recent';
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

    var meta = document.querySelector('[data-recent-record]');
    if (meta) {
      var item = {
        handle: meta.dataset.handle, title: meta.dataset.title, url: meta.dataset.url,
        price: meta.dataset.price, image: meta.dataset.image, vendor: meta.dataset.vendor
      };
      var list = read().filter(function (p) { return p.handle !== item.handle; });
      list.unshift(item);
      write(list.slice(0, 12));
    }

    var sec = document.querySelector('[data-recently]');
    if (!sec) return;
    var grid = sec.querySelector('[data-recently-grid]');
    var here = meta ? meta.dataset.handle : null;
    var items = read().filter(function (p) { return p.handle !== here; }).slice(0, 4);
    if (!items.length) return;

    grid.innerHTML = items.map(function (p) {
      return '<article class="card"><a class="card__media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
        (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="card__body">' +
        (p.vendor ? '<div class="card__brand">' + p.vendor + '</div>' : '') +
        '<h3 class="card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
        '<div class="card__foot"><div class="price"><span class="price__now">' + p.price + '</span></div></div>' +
        '</div></article>';
    }).join('');
    sec.hidden = false;

    var clear = sec.querySelector('[data-recently-clear]');
    if (clear) clear.addEventListener('click', function () { write([]); sec.hidden = true; });
  })();

  /* ---------- Basket: quantity change and promo code ---------- */
  document.querySelectorAll('[data-auto-submit-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var f = sel.closest('form');
      if (f) f.submit();
    });
  });

  (function () {
    var apply = document.querySelector('[data-promo-apply]');
    var field = document.querySelector('[data-promo-code]');
    if (!apply || !field) return;
    function go() {
      var code = field.value.trim();
      if (!code) return;
      // Shopify applies a code via this route, then returns to the basket
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    }
    apply.addEventListener('click', go);
    field.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); go(); }
    });
  })();

  /* ---------- Facet + sort auto-submit ---------- */
  document.querySelectorAll('[data-auto-submit]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });
})();
